import React, { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
  Outlet,
} from "react-router-dom";

import Header from "./components/header";
import Footer from "./components/footer";
import Spinner from "./components/spinner";
import Home from "./components/home";
import Support from "./components/support";
import Services from "./pages/services";
import About from "./pages/about";
import Contact from "./pages/contact";
import Features from "./pages/features";
import OurTeam from "./pages/ourteam";
import Testimonial from "./pages/testimonial";
import Quotation from "./pages/quotation";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Pagenotfound from "./pages/pagenotfound";
import Leadhero from "./pages/Leadhero";
import LeadFeatures from "./pages/LeadFeatures";
import LeadFlow from "./pages/LeadFlow";
import Landing from "./pages/Landing";

/* =========================
   Scroll To Top
========================= */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

/* =========================
   Layout
========================= */
function Layout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Spinner />
      <Outlet />
      <Footer />
    </>
  );
}

/* =========================
   Router
========================= */
const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <Pagenotfound />,
    children: [
      {
        index: true,
        element: (
          <>
            <Home />
            <Leadhero />
            <LeadFeatures />
            <LeadFlow />
            <Landing />
            <Support />
            <Services />
          </>
        ),
      },
      {
        path: "home",
        element: (
          <>
            <Home />
            <Leadhero />
            <LeadFeatures />
            <LeadFlow />
            <Landing />
            <Support />
            <Services />
          </>
        ),
      },
      { path: "about", element: <About /> },
      { path: "ourteam", element: <OurTeam /> },
      { path: "support", element: <Support /> },
      { path: "contact", element: <Contact /> },
      { path: "quotation", element: <Quotation /> },
      { path: "services", element: <Services /> },
      { path: "testimonial", element: <Testimonial /> }, 
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "terms", element: <TermsAndConditions /> },
      { path: "features", element: <Features /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
